import clotureApi from '@/api/cloture.api'
import { numtiersCible } from '@/utils/destinataire'
import { anneeRecolteCible } from '@/utils/annee-recolte'
import { estMontantNul } from '@/utils/restitution'
import { isPanneServeur } from '@/utils/requete'

const module = {
  namespaced: true,

  state: {
    atelierCultureVerrouillage: null,
    atelierCultureVerrouillageCharge: false,
    atelierCultureVerrouillageErreur: false,
    resumeSynthese: null,
    resumePrixEquilibre: null,
    resumePrixEquilibreCharge: false,
    resumePrixEquilibreGroupe: {
      perso: {},
      quartiles: []
    },
    tresorerieDisponible: null,
    tresorerieDisponibleChargee: false,
    evolutionTresorerieDisponible: null,
    tresorerieDisponibleGroupe: null,
    restitution: null,
    evolution: null,
    loadingRestitution: false,
    erreurRestitution: false,
    resumeCloture: null,
    evolutionResume: null,
    groupeResume: null,
    groupeRestitution: null,
    loadingGroupe: false,
    erreurGroupe: false,
    repartitionChiffreAffaires: null,
    repartitionChiffreAffairesParCulture: null,
    evolutionChiffreAffaires: null,
    repartitionChiffreAffairesCulturesGroupe: null,
    repartitionChiffreAffairesGroupe: null,
    repartitionMainOeuvre: null,
    repartitionMainOeuvreGroupe: null,
    matriceGainTresorerie: null,
    matriceGainTresorerieChargee: false,
    repartitionTresorerie: null,
    evolutionTresorerie: null,
    repartitionTresorerieGroupe: null
  },

  getters: {
    repartitionChiffreAffaires (state) {
      return state.repartitionChiffreAffaires
    },
    repartitionChiffreAffairesParCulture (state) {
      return state.repartitionChiffreAffairesParCulture
    },
    evolutionChiffreAffaires (state) {
      return state.evolutionChiffreAffaires
    },
    repartitionChiffreAffairesCulturesGroupe (state) {
      return state.repartitionChiffreAffairesCulturesGroupe
    },
    repartitionChiffreAffairesGroupe (state) {
      return state.repartitionChiffreAffairesGroupe
    },
    repartitionMainOeuvre (state) {
      return state.repartitionMainOeuvre
    },
    repartitionMainOeuvreGroupe (state) {
      return state.repartitionMainOeuvreGroupe
    },
    atelierCultureVerrouillage (state) {
      return state.atelierCultureVerrouillage
    },
    atelierCultureVerrouillageCharge (state) {
      return state.atelierCultureVerrouillageCharge
    },
    atelierCultureVerrouillageErreur (state) {
      return state.atelierCultureVerrouillageErreur
    },
    resumeSynthese (state) {
      return state.resumeSynthese
    },
    resumePrixEquilibreCharge (state) {
      return state.resumePrixEquilibreCharge
    },
    resumePrixEquilibre (state) {
      return state.resumePrixEquilibre
    },
    resumePrixEquilibreGroupe (state) {
      return state.resumePrixEquilibreGroupe
    },
    tresorerieDisponible (state) {
      return state.tresorerieDisponible
    },
    tresorerieDisponibleChargee (state) {
      return state.tresorerieDisponibleChargee
    },
    evolutionTresorerieDisponible (state) {
      return state.evolutionTresorerieDisponible
    },
    tresorerieDisponibleGroupe (state) {
      return state.tresorerieDisponibleGroupe
    },
    restitution (state) {
      return state.restitution
    },
    evolution (state) {
      return state.evolution
    },
    loadingRestitution (state) {
      return state.loadingRestitution
    },
    erreurRestitution (state) {
      return state.erreurRestitution
    },
    resumeCloture (state) {
      return state.resumeCloture
    },
    evolutionResume (state) {
      return state.evolutionResume
    },
    groupeResume (state) {
      return state.groupeResume
    },
    groupeRestitution (state) {
      return state.groupeRestitution
    },
    loadingGroupe (state) {
      return state.loadingGroupe
    },
    erreurGroupe (state) {
      return state.erreurGroupe
    },
    aDesCoproduits (state) {
      if (state.resumeCloture != null) {
        return !estMontantNul(state.resumeCloture.totalCoproduits)
      }
      if (state.restitution != null && state.restitution.coproduit != null) {
        return !estMontantNul(state.restitution.coproduit.coproduits)
      }
      return true
    },
    hasEvolution (state) {
      if (state.evolutionResume != null) {
        return Object.values(state.evolutionResume).some(
          (champ) => champ != null && champ.evolutionMontantEnPourcentage != null
        )
      }
      if (state.evolution == null) {
        return false
      }
      return Object.values(state.evolution).some(
        (volet) => volet != null && volet.total != null && volet.total.evolutionMontantEnPourcentage != null
      )
    },
    matriceGainTresorerie (state) {
      return state.matriceGainTresorerie
    },
    matriceGainTresorerieChargee (state) {
      return state.matriceGainTresorerieChargee
    },
    repartitionTresorerie (state) {
      return state.repartitionTresorerie
    },
    evolutionTresorerie (state) {
      return state.evolutionTresorerie
    },
    repartitionTresorerieGroupe (state) {
      return state.repartitionTresorerieGroupe
    }
  },
  mutations: {
    UPDATE_REPARTITION_CHIFFRE_AFFAIRES (state, repartitionChiffreAffaires) {
      state.repartitionChiffreAffaires = repartitionChiffreAffaires
    },
    UPDATE_REPARTITION_CHIFFRE_AFFAIRES_PAR_CULTURE (state, repartitionChiffreAffairesParCulture) {
      state.repartitionChiffreAffairesParCulture = repartitionChiffreAffairesParCulture
    },
    UPDATE_EVOLUTION_CHIFFRE_AFFAIRES (state, evolutionChiffreAffaires) {
      state.evolutionChiffreAffaires = evolutionChiffreAffaires
    },
    UPDATE_REPARTITION_CHIFFRE_AFFAIRES_CULTURES_GROUPE (state, repartitionChiffreAffairesCulturesGroupe) {
      state.repartitionChiffreAffairesCulturesGroupe = repartitionChiffreAffairesCulturesGroupe
    },
    UPDATE_REPARTITION_CHIFFRE_AFFAIRES_GROUPE (state, repartitionChiffreAffairesGroupe) {
      state.repartitionChiffreAffairesGroupe = repartitionChiffreAffairesGroupe
    },
    UPDATE_REPARTITION_MAIN_OEUVRE (state, repartitionMainOeuvre) {
      state.repartitionMainOeuvre = repartitionMainOeuvre
    },
    UPDATE_REPARTITION_MAIN_OEUVRE_GROUPE (state, repartitionMainOeuvreGroupe) {
      state.repartitionMainOeuvreGroupe = repartitionMainOeuvreGroupe
    },
    DEBUT_CHARGEMENT_ATELIER_CULTURE_VERROUILLAGE (state) {
      state.atelierCultureVerrouillageCharge = false
      state.atelierCultureVerrouillageErreur = false
    },
    UPDATE_ATELIER_CULTURE_VEROUILLAGE (state, atelierCultureVerrouillage) {
      state.atelierCultureVerrouillage = atelierCultureVerrouillage
      state.atelierCultureVerrouillageCharge = true
      state.atelierCultureVerrouillageErreur = false
    },
    ECHEC_CHARGEMENT_ATELIER_CULTURE_VERROUILLAGE (state) {
      state.atelierCultureVerrouillage = null
      state.atelierCultureVerrouillageCharge = false
      state.atelierCultureVerrouillageErreur = true
    },
    UPDATE_RESUME_SYNTHESE_CULTURE (state, resumeSynthese) {
      state.resumeSynthese = resumeSynthese
    },
    DEBUT_CHARGEMENT_RESUME_PRIX_EQUILIBRE (state) {
      state.resumePrixEquilibreCharge = false
    },
    UPDATE_RESUME_PRIX_EQUILIBRE (state, resumePrixEquilibre) {
      state.resumePrixEquilibre = resumePrixEquilibre
      state.resumePrixEquilibreCharge = true
    },
    DEBUT_CHARGEMENT_TRESORERIE_DISPONIBLE (state) {
      state.tresorerieDisponibleChargee = false
    },
    UPDATE_TRESORERIE_DISPONIBLE (state, tresorerieDisponible) {
      state.tresorerieDisponible = tresorerieDisponible
      state.tresorerieDisponibleChargee = true
    },
    UPDATE_EVOLUTION_TRESORERIE_DISPONIBLE (state, evolutionTresorerieDisponible) {
      state.evolutionTresorerieDisponible = evolutionTresorerieDisponible
    },
    UPDATE_TRESORERIE_DISPONIBLE_GROUPE (state, tresorerieDisponibleGroupe) {
      state.tresorerieDisponibleGroupe = tresorerieDisponibleGroupe
    },
    UPDATE_RESUME_PRIX_EQUILIBRE_GROUPE (state, resumePrixEquilibreGroupe) {
      state.resumePrixEquilibreGroupe = resumePrixEquilibreGroupe
    },
    UPDATE_RESTITUTION (state, restitution) {
      state.restitution = restitution
    },
    UPDATE_EVOLUTION (state, evolution) {
      state.evolution = evolution
    },
    UPDATE_LOADING_RESTITUTION (state, loading) {
      state.loadingRestitution = loading
    },
    UPDATE_ERREUR_RESTITUTION (state, erreur) {
      state.erreurRestitution = erreur
    },
    UPDATE_RESUME_CLOTURE (state, resumeCloture) {
      state.resumeCloture = resumeCloture
    },
    UPDATE_EVOLUTION_RESUME (state, evolutionResume) {
      state.evolutionResume = evolutionResume
    },
    UPDATE_GROUPE_RESUME (state, groupeResume) {
      state.groupeResume = groupeResume
    },
    UPDATE_GROUPE_RESTITUTION (state, groupeRestitution) {
      state.groupeRestitution = groupeRestitution
    },
    UPDATE_LOADING_GROUPE (state, loading) {
      state.loadingGroupe = loading
    },
    UPDATE_ERREUR_GROUPE (state, erreur) {
      state.erreurGroupe = erreur
    },
    DEBUT_CHARGEMENT_MATRICE_GAIN_TRESORERIE (state) {
      state.matriceGainTresorerie = null
      state.matriceGainTresorerieChargee = false
    },
    UPDATE_MATRICE_GAIN_TRESORERIE (state, matriceGainTresorerie) {
      state.matriceGainTresorerie = matriceGainTresorerie
      state.matriceGainTresorerieChargee = true
    },
    UPDATE_REPARTITION_TRESORERIE (state, repartitionTresorerie) {
      state.repartitionTresorerie = repartitionTresorerie
    },
    UPDATE_EVOLUTION_TRESORERIE (state, evolutionTresorerie) {
      state.evolutionTresorerie = evolutionTresorerie
    },
    UPDATE_REPARTITION_TRESORERIE_GROUPE (state, repartitionTresorerieGroupe) {
      state.repartitionTresorerieGroupe = repartitionTresorerieGroupe
    },
  },
  actions: {
    async getRepartitionTresorerie ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getRepartitionTresorerie(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_REPARTITION_TRESORERIE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_TRESORERIE', null)
          throw erreur
        })
    },
    async getEvolutionTresorerie ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getEvolutionTresorerie(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_EVOLUTION_TRESORERIE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_EVOLUTION_TRESORERIE', null)
          throw erreur
        })
    },
    async getRepartitionTresorerieGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return clotureApi.getRepartitionTresorerieGroupe(username, anneeRecolte, filtres)
        .then(response => {
          commit('UPDATE_REPARTITION_TRESORERIE_GROUPE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_TRESORERIE_GROUPE', null)
          throw erreur
        })
    },
    async getRepartitionChiffreAffaires ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getRepartitionChiffreAffaires(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES', null)
          throw erreur
        })
    },
    async getRepartitionChiffreAffairesParCulture ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getRepartitionChiffreAffairesParCulture(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_PAR_CULTURE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_PAR_CULTURE', null)
          throw erreur
        })
    },
    async getEvolutionChiffreAffaires ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getEvolutionChiffreAffaires(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_EVOLUTION_CHIFFRE_AFFAIRES', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_EVOLUTION_CHIFFRE_AFFAIRES', null)
          throw erreur
        })
    },
    async getRepartitionChiffreAffairesCulturesGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return clotureApi.getRepartitionChiffreAffairesCulturesGroupe(username, anneeRecolte, filtres)
        .then(response => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_CULTURES_GROUPE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_CULTURES_GROUPE', null)
          throw erreur
        })
    },
    async getRepartitionChiffreAffairesGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return clotureApi.getRepartitionChiffreAffairesGroupe(username, anneeRecolte, filtres)
        .then(response => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_GROUPE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_CHIFFRE_AFFAIRES_GROUPE', null)
          throw erreur
        })
    },
    async getRepartitionMainOeuvre ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getRepartitionMainOeuvre(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_REPARTITION_MAIN_OEUVRE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_MAIN_OEUVRE', null)
          throw erreur
        })
    },

    async getRepartitionMainOeuvreGroupe ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return clotureApi.getRepartitionMainOeuvreGroupe(username, anneeRecolte, filtres)
        .then(response => {
          commit('UPDATE_REPARTITION_MAIN_OEUVRE_GROUPE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_REPARTITION_MAIN_OEUVRE_GROUPE', null)
          throw erreur
        })
    },
    async getAtelierCultureVerrouillage ({ commit, rootGetters }) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      commit('DEBUT_CHARGEMENT_ATELIER_CULTURE_VERROUILLAGE')

      const demanderVerrouillage = () => clotureApi.getAtelierCultureVerrouillage(username, anneeRecolte)

      return demanderVerrouillage()
        .catch(erreur => isPanneServeur(erreur) ? demanderVerrouillage() : Promise.reject(erreur))
        .then(response => {
          commit('UPDATE_ATELIER_CULTURE_VEROUILLAGE', response)
          return response
        })
        .catch(erreur => {
          if (isPanneServeur(erreur)) {
            commit('ECHEC_CHARGEMENT_ATELIER_CULTURE_VERROUILLAGE')
          } else {
            commit('UPDATE_ATELIER_CULTURE_VEROUILLAGE', null)
          }
          throw erreur
        })
    },
    async getResumeSyntheseCulture ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      return clotureApi.getResumeSyntheseCulture(username, anneeRecolte, codeTypeCulture)
        .then(response => {
          commit('UPDATE_RESUME_SYNTHESE_CULTURE', response)
          return response
        })
    },
    async getResumePrixEquilibre ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      commit('DEBUT_CHARGEMENT_RESUME_PRIX_EQUILIBRE')
      return clotureApi.getResumePrixEquilibre(username, anneeRecolte, codeTypeCulture)
        .then(response => {
          commit('UPDATE_RESUME_PRIX_EQUILIBRE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_RESUME_PRIX_EQUILIBRE', null)
          throw erreur
        })
    },
    async getResumePrixEquilibreGroupe ({ commit, rootGetters }, params) {
      const username = numtiersCible(rootGetters)
      return clotureApi.construireResumeGroupeRepartitionPrixEquilibre(username, params)
        .then(response => {
          commit('UPDATE_RESUME_PRIX_EQUILIBRE_GROUPE', response)
          return response
        })
    },
    async getTresorerieDisponible ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      commit('DEBUT_CHARGEMENT_TRESORERIE_DISPONIBLE')
      commit('UPDATE_EVOLUTION_TRESORERIE_DISPONIBLE', null)
      commit('UPDATE_TRESORERIE_DISPONIBLE_GROUPE', null)

      const evolution = clotureApi.getEvolutionTresorerieCulture(username, anneeRecolte, codeTypeCulture)
        .then(response => commit('UPDATE_EVOLUTION_TRESORERIE_DISPONIBLE', response))
        .catch(() => commit('UPDATE_EVOLUTION_TRESORERIE_DISPONIBLE', null))

      return clotureApi.getTresorerieDisponible(username, anneeRecolte, codeTypeCulture)
        .then(response => {
          commit('UPDATE_TRESORERIE_DISPONIBLE', response)
          return evolution.then(() => response)
        })
        .catch(erreur => {
          commit('UPDATE_TRESORERIE_DISPONIBLE', null)
          throw erreur
        })
    },

    async getTresorerieDisponibleGroupe ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent']
      return clotureApi.getTresorerieDisponibleGroupe(username, anneeRecolte, codeTypeCulture, filtres)
        .then(response => {
          commit('UPDATE_TRESORERIE_DISPONIBLE_GROUPE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_TRESORERIE_DISPONIBLE_GROUPE', null)
          throw erreur
        })
    },

    async getRestitution ({ commit, dispatch, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)

      commit('UPDATE_LOADING_RESTITUTION', true)
      commit('UPDATE_ERREUR_RESTITUTION', false)

      try {
        const { restitution, evolution, resume, evolutionResume } = await dispatch('chargerRestitution', { username, anneeRecolte, codeTypeCulture })
        commit('UPDATE_RESTITUTION', restitution)
        commit('UPDATE_EVOLUTION', evolution)
        commit('UPDATE_RESUME_CLOTURE', resume)
        commit('UPDATE_EVOLUTION_RESUME', evolutionResume)
      } catch (erreur) {
        commit('UPDATE_RESTITUTION', null)
        commit('UPDATE_EVOLUTION', null)
        commit('UPDATE_RESUME_CLOTURE', null)
        commit('UPDATE_EVOLUTION_RESUME', null)
        commit('UPDATE_ERREUR_RESTITUTION', true)
        throw erreur
      } finally {
        commit('UPDATE_LOADING_RESTITUTION', false)
      }

      return true
    },

    async chargerRestitution (contexte, { username, anneeRecolte, codeTypeCulture }) {
      const [
        chargeFixe, chargeVariable, coproduit, autresProduits,
        evolutionChargeFixe, evolutionChargeVariable, evolutionCoproduit, evolutionAutresProduits,
        resume, evolutionResume
      ] = await Promise.all([
        clotureApi.getRestitutionChargeFixe(username, anneeRecolte, codeTypeCulture),
        clotureApi.getRestitutionChargeVariable(username, anneeRecolte, codeTypeCulture),
        clotureApi.getRestitutionCoproduit(username, anneeRecolte, codeTypeCulture),
        clotureApi.getRestitutionAutresProduits(username, anneeRecolte, codeTypeCulture),
        clotureApi.getEvolutionChargeFixe(username, anneeRecolte, codeTypeCulture),
        clotureApi.getEvolutionChargeVariable(username, anneeRecolte, codeTypeCulture),
        clotureApi.getEvolutionCoproduit(username, anneeRecolte, codeTypeCulture),
        clotureApi.getEvolutionAutresProduits(username, anneeRecolte, codeTypeCulture),
        clotureApi.getResumeCloture(username, anneeRecolte, codeTypeCulture),
        clotureApi.getEvolutionResumeCloture(username, anneeRecolte, codeTypeCulture)
      ])
      return {
        restitution: { chargeFixe, chargeVariable, coproduit, autresProduits },
        evolution: {
          chargeFixe: evolutionChargeFixe,
          chargeVariable: evolutionChargeVariable,
          coproduit: evolutionCoproduit,
          autresProduits: evolutionAutresProduits
        },
        resume,
        evolutionResume
      }
    },

    async getGroupeRestitution ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      const filtres = rootGetters['filtresComparaison/filtresAdherent'] || {}

      commit('UPDATE_LOADING_GROUPE', true)
      commit('UPDATE_ERREUR_GROUPE', false)

      try {
        const [chargeFixe, chargeVariable, coproduit, autresProduits, resume] = await Promise.all([
          clotureApi.getGroupeChargeFixe(username, anneeRecolte, codeTypeCulture, filtres),
          clotureApi.getGroupeChargeVariable(username, anneeRecolte, codeTypeCulture, filtres),
          clotureApi.getGroupeCoproduit(username, anneeRecolte, codeTypeCulture, filtres),
          clotureApi.getGroupeAutresProduits(username, anneeRecolte, codeTypeCulture, filtres),
          clotureApi.getGroupeResumeCloture(username, anneeRecolte, codeTypeCulture, filtres)
        ])
        commit('UPDATE_GROUPE_RESTITUTION', { chargeFixe, chargeVariable, coproduit, autresProduits })
        commit('UPDATE_GROUPE_RESUME', resume)
      } catch (erreur) {
        commit('UPDATE_GROUPE_RESTITUTION', null)
        commit('UPDATE_GROUPE_RESUME', null)
        commit('UPDATE_ERREUR_GROUPE', true)
      } finally {
        commit('UPDATE_LOADING_GROUPE', false)
      }

      return true
    },

    async getMatriceGainTresorerie ({ commit, rootGetters }, codeTypeCulture) {
      const username = numtiersCible(rootGetters)
      const anneeRecolte = anneeRecolteCible(rootGetters)
      commit('DEBUT_CHARGEMENT_MATRICE_GAIN_TRESORERIE')
      return clotureApi.getMatriceGainTresorerie(username, anneeRecolte, codeTypeCulture)
        .then(response => {
          commit('UPDATE_MATRICE_GAIN_TRESORERIE', response)
          return response
        })
        .catch(erreur => {
          commit('UPDATE_MATRICE_GAIN_TRESORERIE', null)
          throw erreur
        })
    },

    resetRestitution ({ commit }) {
      commit('UPDATE_RESTITUTION', null)
      commit('UPDATE_EVOLUTION', null)
      commit('UPDATE_RESUME_CLOTURE', null)
      commit('UPDATE_EVOLUTION_RESUME', null)
      commit('UPDATE_ERREUR_RESTITUTION', false)
      commit('UPDATE_LOADING_RESTITUTION', false)
      commit('UPDATE_GROUPE_RESTITUTION', null)
      commit('UPDATE_GROUPE_RESUME', null)
      commit('UPDATE_ERREUR_GROUPE', false)
      commit('UPDATE_LOADING_GROUPE', false)
    }

  }
}

export default module
